import React, { useState } from 'react';
import { PayPalButtons } from "@paypal/react-paypal-js";
import { useTranslation } from 'react-i18next';
import { Capacitor } from '@capacitor/core';
import { IapService } from '../services/IapService';

const PurchaseConfirmationModal = ({ onClose, handleBuyEchoes, onApprove, itemId, price, tokens, isCashout = false }) => {
    const { t } = useTranslation();
    const [isPurchasingNative, setIsPurchasingNative] = useState(false);
    const isNative = Capacitor.getPlatform() !== 'web';

    const handleNativePurchase = async () => {
        setIsPurchasingNative(true);
        try {
            // Find the package using RevenueCat
            const offerings = await IapService.getOfferings();
            if (offerings && offerings.current && offerings.current.availablePackages) {
                // Assuming package identifiers correspond to itemId (e.g., '1000_echoes')
                const pkg = offerings.current.availablePackages.find(p => p.identifier === itemId);
                if (pkg) {
                    await IapService.purchasePackage(pkg);
                    // On success, we need to call a Cloud Function to grant tokens. 
                    // This is handled by RevenueCat webhooks, but we can do client-side optimistic UI or call our onApprove directly.
                    // For simplicity, we assume successful native purchase is validated on server and we tell client to approve.
                    onApprove({ orderID: 'native_' + Date.now(), success: true, isNative: true });
                } else {
                    alert('Package not found in RevenueCat');
                }
            } else {
                alert('No packages available');
            }
        } catch (error) {
            console.error("Native purchase failed", error);
        } finally {
            setIsPurchasingNative(false);
        }
    };
    return (
        <div className="modal-overlay">
            <div className="bg-gray-800 rounded-lg p-6 max-w-sm w-full">
                <h3 className="text-lg font-bold mb-4">{isCashout ? t('purchaseConfirmation.cashoutTitle') : t('purchaseConfirmation.purchaseTitle')}</h3>
                <div className="text-center text-white mb-4">
                    {isCashout ? (
                        <>
                            <p>{t('purchaseConfirmation.cashoutMessage1')}</p>
                            <p className="text-2xl font-bold text-blue-300">{tokens.toLocaleString()} {t('purchaseConfirmation.echoes')}</p>
                            <p>{t('purchaseConfirmation.for')}</p>
                            <p className="text-2xl font-bold text-green-300">${price}</p>
                            <p>{t('purchaseConfirmation.cashoutMessage2')}</p>
                        </>
                    ) : (
                        <>
                            <p>{t('purchaseConfirmation.purchaseMessage1')}</p>
                            <p className="text-2xl font-bold text-blue-300">{tokens.toLocaleString()} {t('purchaseConfirmation.echoes')}</p>
                            <p>{t('purchaseConfirmation.for')}</p>
                            <p className="text-2xl font-bold text-green-300">${price}</p>
                        </>
                    )}
                </div>
                {!isCashout && !isNative && (
                    <PayPalButtons createOrder={() => handleBuyEchoes(itemId, tokens)} onApprove={onApprove} />
                )}
                {!isCashout && isNative && (
                    <button 
                        onClick={handleNativePurchase}
                        disabled={isPurchasingNative}
                        className="w-full mt-4 small-action-button bg-blue-600 hover:bg-blue-700 font-bold"
                    >
                        {isPurchasingNative ? 'Processing...' : `Buy with ${Capacitor.getPlatform() === 'ios' ? 'Apple' : 'Google'} Pay`}
                    </button>
                )}
                <button onClick={onClose} className="w-full mt-4 small-action-button bg-red-600 hover:bg-red-700">{isCashout ? t('purchaseConfirmation.close') : t('purchaseConfirmation.cancel')}</button>
            </div>
        </div>
    );
};

export default PurchaseConfirmationModal;
